import { enableMapSet } from 'immer';
import { message } from 'antd';
import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import useSimpleLogger from '@/hooks/useSimpleLogger';
import background from '@/assets/img/background.png';
import Navbar from './components/navbar/Navbar';
import useAuth from './hooks/useAuth';
import YIXIAOHOC from './libs/yixiaoEntryHOC';
import { setCookie } from './libs/utils/cookie-tool';
import { clearUserData } from './reducers/users';
import { useDispatch } from 'react-redux';
import ParseTokenLoginHOC from './libs/tokenLoginHOC';
import { compose } from '@reduxjs/toolkit';

message.config({ top: 120 });
enableMapSet();

function App() {
  const dispatch = useDispatch();
  const location = useLocation();
  const { usePageLogger, useCourseLogger } = useSimpleLogger();
  const { logPageEnter } = usePageLogger(location.pathname);
  const { checkLogin } = useAuth();
  useCourseLogger(location.pathname);
  useEffect(() => {
    logPageEnter();
  }, [location.pathname]);
  useEffect(() => {
    checkLogin();
  }, []);
  useEffect(() => {
    function handleOnUnload() {
      const result = localStorage.getItem('clearWhenPageExit');
      if (result === 'true') {
        dispatch(clearUserData());
        setCookie('uuid', '', 0);
        localStorage.removeItem('uid');
        localStorage.removeItem('userData');
        localStorage.removeItem('clearWhenPageExit');
        console.log('清空数据');
      }
    }
    window.onbeforeunload = handleOnUnload;
    return () => {
      handleOnUnload();
    };
  }, []);

  // const hideNavbar = /^\/(teaching-research|teachingBlock|share)(\/|$)/.test(location.pathname);
  const hideNavbar = /^\/(teachingBlock|share)(\/|$)/.test(location.pathname);

  return (
    <div
      style={{
        backgroundImage: `url(${background})`,
        backgroundSize: '100% auto',
        backgroundRepeat: 'repeat',
        height: hideNavbar ? '100%' : 'auto',
      }}
    >
      {!hideNavbar && <Navbar />}
      <div style={{ height: hideNavbar ? '100%' : 'auto' }}>
        <Outlet />
      </div>
    </div>
  );
}

export default compose(YIXIAOHOC, ParseTokenLoginHOC)(App);
